import { CommonStyles } from '../BaseProps/index.es.js';
import styled from '@emotion/styled';

const Shape = styled.div`
  ${CommonStyles};
`;

export { Shape };
